/**
 * 51esc web — entry point: `/cvn-top10.html`.
 *
 * Top 10 apontadores (Fase 5g.3): ranking del escuadrón por media de
 * calificación LSO. Consume `GET /api/greenie-board` (5g.2) y
 * `GET /api/pilots` (para la foto del nº 1). Se llega desde el hotspot
 * del proyector de la ready room (`/portaaviones.html`).
 */

import { mountCvnTop10 } from './modules/cvn-top10/mount.js';

void mountCvnTop10();
